export default __webpack_public_path__ + "static/media/sedex-logo-7.86728eeb.png";